const countries = [
  ["Kenya", "🇰🇪"],
];

export default function CountryStep({ country, setCountry }) {
  return (
    <div style={{ marginBottom: 40 }}>
      <h3 style={{
        fontSize: "14px",
        textTransform: "uppercase",
        color: "#C4773B",
        marginBottom: 20
      }}>
        Step 2 — Select your country
      </h3>

      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: 8
      }}>
        {countries.map(([name, flag]) => (
          <button
            key={name}
            onClick={() => setCountry(name)}
            style={{
              padding: "12px 14px",
              border: country === name
                ? "1px solid #C4773B"
                : "1px solid rgba(26,22,17,0.12)",
              background: country === name
                ? "rgba(196,119,59,0.12)"
                : "transparent",
              cursor: "pointer",
              display: "flex",
              gap: 8,
              alignItems: "center"
            }}
          >
            <span>{flag}</span>
            <span style={{ fontSize: 14 }}>{name}</span>
            {country === name && (
              <span style={{ marginLeft: "auto", color: "#C4773B" }}>✓</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}